/** Status helpers shared by pages. */
import type { Mapping } from "@/api/types";

/** Turns warning past 50 % of the alert threshold and danger past it. */
export function levelFor(value: number, threshold: number): "" | "warning" | "danger" {
  if (value >= threshold) return "danger";
  if (value >= threshold / 2) return "warning";
  return "";
}

/**
 * live / paused / failing / idle(disabled) for a mapping. Same precedence as the graph:
 * disabled > paused > failing > live. `failing` is server-computed (dead message in 24 h).
 */
export function mappingStatus(m: Mapping): {
  status: "live" | "paused" | "dead" | "idle";
  label: string;
} {
  if (!m.enabled) return { status: "idle", label: "Disabled" };
  if (m.paused_reason) return { status: "paused", label: `Paused · ${m.paused_reason.replace(/_/g, " ")}` };
  if (m.failing) return { status: "dead", label: "Failing" };
  return { status: "live", label: "Live" };
}
